import { render, staticRenderFns } from "./CopyLinkButton.vue?vue&type=template&id=7010f7ee&scoped=true"
import script from "./CopyLinkButton.vue?vue&type=script&lang=ts"
export * from "./CopyLinkButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyLinkButton.vue?vue&type=style&index=0&id=7010f7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010f7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VHover,VIcon,VSnackbar,VTooltip})
